import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Home, Mail } from "lucide-react";
import { NAV_LINKS } from "@/data/content";

const iconFor = (href) => {
  if (href === "#anasayfa") return Home;
  if (href === "#iletisim") return Mail;
  return null;
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 bg-white transition-shadow duration-300 ${
        scrolled ? "shadow-[0_4px_20px_rgba(18,58,114,0.10)]" : ""
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 lg:px-8 h-[68px] flex items-center justify-between">
        <a href="#anasayfa" data-testid="brand-logo" className="flex items-center">
          <span className="font-extrabold text-brand text-xl sm:text-2xl tracking-tight">
            TÜRKİYE BORSA ROBOTU
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {NAV_LINKS.map((l) => {
            const Icon = iconFor(l.href);
            return (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-${l.href.slice(1)}`}
                className="inline-flex items-center gap-1.5 px-3.5 py-2 text-[15px] font-semibold text-slate-700 hover:text-brand transition-colors relative after:absolute after:left-3.5 after:right-3.5 after:-bottom-0.5 after:h-[2px] after:bg-brand after:scale-x-0 hover:after:scale-x-100 after:origin-left after:transition-transform after:duration-300"
              >
                {Icon && <Icon className="w-4 h-4" strokeWidth={2} />}
                {l.label}
              </a>
            );
          })}
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden grid place-items-center w-10 h-10 rounded-lg text-brand bg-brand-light"
          aria-label="Menü"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="lg:hidden overflow-hidden bg-white border-t border-slate-100"
          >
            <div className="px-5 py-3 flex flex-col">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-${l.href.slice(1)}`}
                  className="py-3 text-slate-700 font-semibold border-b border-slate-100 last:border-0"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
